import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';

const getUrl = ({ host, deviceId }: { host: string; deviceId: string }) => {
  return `${host}/gateway-cloud/devices/${deviceId}`;
};

export const DeleteDeviceDetailWithoutGateway = async ({
  token,
  host,
  deviceId,
}: {
  token: string;
  host: string;
  deviceId: string;
}): Promise<void> => {
  try {
    const url = getUrl({ host, deviceId });

    const options: AxiosRequestConfig = {
      url,
      method: 'DELETE',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<void>;
    return data;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
